import React from "react"
import ReactTable from "react-table"
import StyledLink from "components/Atoms/StyledLink"
import StatusIcon from "components/Atoms/StatusIcon"

const ContractTable = ({ contracts, vehicle }) => {
  const COLUMNS = [
    {
      Header: "Number",
      accessor: "contractCode",
      Cell({ value, original }) {
        return (
          <StyledLink
            to={{
              pathname: `/d/registration/contract/${original?.id}`,
            }}
            state={vehicle}
          >
            {value}
          </StyledLink>
        )
      },
    },
    {
      Header: "Contract Type",
      accessor: "contractType.name",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell({ value }) {
        return (
          <StatusIcon
            values={{
              CM: { intent: "success", text: "CM", tooltip: "Completed" },
              EX: { intent: "danger", text: "EX", tooltip: "Expired" },
              AC: { intent: "warning", text: "AC", tooltip: "Active" },
              IN: { intent: "none", text: "IN", tooltip: "Inactive" },
            }}
            condition={value}
          ></StatusIcon>
        )
      },
    },
    {
      Header: "Start Date",
      accessor: "startDate",
    },
    {
      Header: "End Date",
      accessor: "endDate",
    },
    {
      Header: "Total Expense",
      accessor: "totalExpense",
    },
    {
      Header: "Total Paid",
      accessor: "totalPaid",
    },
  ]
  return (
    <ReactTable
      className="-highlight vt-contracts-table"
      showPaginationBottom={false}
      columns={COLUMNS}
      data={contracts ?? []}
    />
  )
}

export default ContractTable
